export const MAX_PERFORMANCE_VALUE = 110